import React from "react";
import Breadcrumb from "./Breadcrumb";
import { Link, useLocation } from "react-router-dom";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import FiscalYearSwitcher from "../../rbm/components/FiscalYearSwitcher";
import EmploymentSwitcher from "../../rbm/components/EmploymentSwitcher";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";

const MenuBar = () => {
  const location = useLocation();

  return (
    <>
      <nav>
        <div
          className="py-1 d-flex flex-wrap justify-content-between mt-0  align-items-center px-4"
          style={{
            backgroundColor: "#078ece",
            borderBottom: "1px solid #078ece",
            borderTop: "1px solid #078ece",
          }}
        >
          <Breadcrumb />

          <div className="d-flex flex-wrap justify-content-end align-items-center pl-2">
            <Link
              style={{ textDecoration: "none", color: "#fff" }}
              to="/leave/user-guide"
              className={`  px-1 rounded mr-3 d-none d-md-inline  ${
                location.pathname.includes("/leave/user-guide") ? "active" : " "
              }`}
            >
              <span className="text-truncate font-weight-bold menu-item d-flex">
                <LocalLibraryIcon />
                User-Guide
              </span>
            </Link>
            {/* <HorizontalRuleIcon className="rotated" />
            <FiscalYearSwitcher />
            <HorizontalRuleIcon className="rotated" />
            <EmploymentSwitcher /> */}
          </div>
        </div>
      </nav>
    </>
  );
};

export default MenuBar;
